export const selectApplicationName = (state) => state.applicationContext.applicationName;
export const selectGainsightLoadState = (state) => !!state.applicationContext.isGainsightLoaded;
